/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramAuthTelegramControllerAuthorizeByTelegramDataMutationRequest,
  TelegramAuthTelegramControllerAuthorizeByTelegramDataMutationResponse,
  TelegramAuthTelegramControllerAuthorizeByTelegramData401,
  TelegramAuthTelegramControllerAuthorizeByTelegramData403,
} from '../types/TelegramAuthTelegramControllerAuthorizeByTelegramData.ts';

function getTelegramAuthTelegramAuthorizeByTelegramDataUrl() {
  const res = { method: 'POST', url: `/api/telegram/auth/telegram/login` as const };
  return res;
}

/**
 * {@link /api/telegram/auth/telegram/login}
 */
export async function telegramAuthTelegramAuthorizeByTelegramData(
  data: TelegramAuthTelegramControllerAuthorizeByTelegramDataMutationRequest,
  config: Partial<RequestConfig<TelegramAuthTelegramControllerAuthorizeByTelegramDataMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramAuthTelegramControllerAuthorizeByTelegramDataMutationResponse,
    ResponseErrorConfig<
      | TelegramAuthTelegramControllerAuthorizeByTelegramData401
      | TelegramAuthTelegramControllerAuthorizeByTelegramData403
    >,
    TelegramAuthTelegramControllerAuthorizeByTelegramDataMutationRequest
  >({
    method: 'POST',
    url: getTelegramAuthTelegramAuthorizeByTelegramDataUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
